export default __webpack_public_path__ + "static/media/7popup.0da54790.jpg";